import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}payroll-overtime-entries`;
const EMPLOYEES_URL = `${process.env.VUE_APP_API_URL}employees`;
const OVERTIME_URL = `${process.env.VUE_APP_API_URL}payroll-overtimes`;

export default {
  async getAll(params = {}) {
    const res = await axios.get(API_URL, {
      headers: buildHeaders(),
      params,
    });
    return res.data;
  },
  async create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },
  async update(id, data) {
    return axios.put(`${API_URL}/${id}`, data, { headers: buildHeaders() });
  },
  async delete(id) {
    return axios.delete(`${API_URL}/${id}`, { headers: buildHeaders() });
  },
  async getEmployees(params = {}) {
    const res = await axios.get(EMPLOYEES_URL, {
      headers: buildHeaders(),
      params,
    });
    return Array.isArray(res.data) ? res.data : [];
  },
  async getOvertimeDefinitions() {
    const res = await axios.get(OVERTIME_URL, { headers: buildHeaders() });
    return Array.isArray(res.data) ? res.data : [];
  },
};
